<template>
    <div @click="open()">
        <v-text-field
            ref="input"
            :value="selectedDateDescription"
            @keydown.enter="open()"
            append-icon="event"
            hide-details
            label="Financial Week"
            outline
            dense
            readonly>
        </v-text-field>
        <v-dialog
            v-if="editMode"
            :value="true"
            persistent
            @keydown.esc='cancel()'
            width="290px">
            <v-date-picker scrollable
                :value="editValue"
                :allowed-dates="allowedDates"
                @input="updateValue">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancel()">Cancel</v-btn>
                <v-btn text color="primary" @click="submit()">OK</v-btn>
            </v-date-picker>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import RosterUtilService from '@/services/rosterUtilService';
import UtilService from '@/services/utilService';
import { mapState } from 'vuex';

export default {
    components: {

    },
    props: {
        value: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            editMode: false,
            localValue: null
        };
    },
    computed: {
        ...mapState("RosterStore", [
            "financialYearCalendarData",
        ]),
        editValue(){
            if(this.localValue == null){
                return moment(this.value).format('YYYY-MM-DD');
            }

            return moment(this.localValue).format('YYYY-MM-DD');
        },
        selectedDateDescription(){
            return `WK${RosterUtilService.getFinancialWeek(this.value, this.financialYearCalendarData)} FY${RosterUtilService.getFinancialYear(this.value, this.financialYearCalendarData)}`;
        }
    },
    methods: {
        open(){
            this.editMode = true;
        },
        updateValue(newValue){
            this.localValue = moment(newValue, "YYYY-MM-DD").format('YYYY-MM-DD');
        },
        cancel(){
            this.localValue = null;
            this.editMode = false;
            UtilService.focusRefElement(this.$refs, 'input');

        },
        submit(){
            this.$emit("input", moment(this.editValue, "YYYY-MM-DD").format('YYYY-MM-DD'));
            this.localValue = null;
            this.editMode = false;
            UtilService.focusRefElement(this.$refs, 'input');
        },
        allowedDates(val){
            var date = new Date(val);
            return date.getDay() == 1 && this.financialYearCalendarData.some(f => f.FinancialYear == date.getFullYear());
        },
    },
    created(){
        
    }
}
</script>